<script lang="ts">
import { type PropType, defineComponent } from 'vue'
import { type RouteLocationAsRelativeTyped, useRouter } from 'vue-router'

/**
 * Renders the current page title with an optional "previous" button.
 */
export default defineComponent({
  props: {
    /**
     * Title of the page. If not specified, the `title` property of the current
     * route `metea` object will be used.
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Route to navigate to when the user clicks the "previous page" button.
     * If `nextRoute` isn't used, this is usually set to the route of the parent
     * page in the navigation hierarchy.
     */
    previousRoute: {
      type: Object as PropType<RouteLocationAsRelativeTyped>,
    },
    /**
     * Route to navigate to when the user clicks the "next page" button.
     */
    nextRoute: {
      type: Object as PropType<RouteLocationAsRelativeTyped>,
    },
  },
  setup() {
    return {
      router: useRouter(),
    }
  },
  computed: {
    pageTitle() {
      return this.title ?? this.router.currentRoute.value.meta.title
    },
  },
})
</script>

<template>
  <AppSection class="pb-0">
    <div
      class="grid max-w-full grid-cols-[3em_1fr_3em] items-center justify-items-center gap-4"
    >
      <RouterLink
        v-if="previousRoute"
        class="button button-new button-new--icon-only justify-self-start"
        title="Previous Page"
        :to="previousRoute"
      >
        <AppIcon icon="ArrowLeft" size="xs" class="sm:h-6 sm:w-6"></AppIcon>
      </RouterLink>
      <h1 class="col-start-2 text-lg font-bold">{{ pageTitle }}</h1>
      <RouterLink
        v-if="nextRoute"
        class="button button-new button-new--icon-only justify-self-start"
        title="next Page"
        :to="nextRoute"
      >
        <AppIcon
          icon="ArrowLeft"
          size="xs"
          class="-scale-x-100 sm:h-6 sm:w-6"
        ></AppIcon>
      </RouterLink>
    </div>
  </AppSection>
</template>
